import * as yup from "yup";

const numberSchema = yup.string()
  .required("Este campo es obligatorio")
  .default("")
  .matches(/^\d+$/, "Debe ser un número");

export default numberSchema;
